<div class="layout-topbar top-bar-custom">
  <div class="topbar-left">
    <img id="logo-mobile" class="logo-desktop" src="../../../../assets/images/header-white-logo.png" alt="PaperTrl"/>
  </div>
</div>
<div class="exception-body mobile-fields" >
  <div class="exception-content">
    <div class="exception-detail">
      <div class="grid">
        <p-card class="card-custom" styleClass="p-card-shadow-remove card-custom">
          <div class="card-custom-padding">
            <h5 class="card-header-custom">Success!</h5>
            <i class="icon fa-solid fa-trophy mb-5"></i>

            <p class="card-subheader-custom">Congratulations! Your vendor registration is now complete.
              Please check your email for further instructions. Thank you for choosing us.</p>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>
